// extracted by mini-css-extract-plugin
export default {"container":"ResourceSearchBanner_container__1xEee","content":"ResourceSearchBanner_content__17klp","searchContent":"ResourceSearchBanner_searchContent__EzoWC"};